import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';

import SetTitle from '../components/shared/SetTitle';
import HelpText from '../components/help/HelpText';
import NoticeBox from '../components/shared/NoticeBox';
import TypeOfPersonSelect from '../components/shared/TypeOfPersonSelect';
import AssignableEventsTable from '../components/events/AssignableEventsTable';
import ModalContainerTrigger from '../components/shared/ModalContainerTrigger';

import { request, handleRequestErrors } from '../helpers/Requests'

import { adminUser, managerUser, setIdAndMethod, renderErrorWarning, renderErrors } from '../utilities/Forms.js'
import { debounce, duration, renderPlannedEventOrAppointment } from '../utilities/Generic.js'

import Audits from '../components/shared/Audits';

class PlannedEventForm extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.closeAssignableEventsModal = this.closeAssignableEventsModal.bind(this);
    this.openAssignableEventsModal = this.openAssignableEventsModal.bind(this);
    this.openAssignableStaffMembersModal = this.openAssignableStaffMembersModal.bind(this);
    this.closeAssignableStaffMembersModal = this.closeAssignableStaffMembersModal.bind(this);
    this.handleStaffMemberCheckboxChange = this.handleStaffMemberCheckboxChange.bind(this);
    this.saveAssignableStaffMembersModal = this.saveAssignableStaffMembersModal.bind(this);
    this.saveAssignableEventsModal = this.saveAssignableEventsModal.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handlePartialChange = this.handlePartialChange.bind(this);
    this.debouncedHandlePersonSearch = debounce(this.handlePersonSearch.bind(this), 500);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleAddRelatedPerson = this.handleAddRelatedPerson.bind(this);
    this.handleAddRelatedHostPerson = this.handleAddRelatedHostPerson.bind(this);
    this.handleAddRelatedArrivingPerson = this.handleAddRelatedArrivingPerson.bind(this);
    this.handleRemovePerson = this.handleRemovePerson.bind(this);
    this.handleGetRelatedPeople = this.handleGetRelatedPeople.bind(this);
    this.handleSelectPerson = this.handleSelectPerson.bind(this);
    this.handleStopGettingRelatedPeople = this.handleStopGettingRelatedPeople.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  state = {
    title: "",
    start_datetime: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-${("0" + new Date().getDate()).slice(-2)}T${this.autoAssignStartTime()}`,
    end_datetime: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-${("0" + new Date().getDate()).slice(-2)}T${this.autoAssignEndTime()}`,
    notes: "",
    service_id: "",

    paid_with_cash: "",
    paid_with_card: "",
    total_amount_paid: "",
    service_price: null,

    addPerson: null,
    partial: "",
    type_of_person: "",
    relationshipPersonID: "",
    host_people: [],
    arriving_people: [],
    temp_arriving_people: null,
    temp_host_people: [],
    showAssignableEventsModal: false,
    showAssignableStaffMembersModal: false,
    assignableEvents: [],
    assignableStaffMembers: [],

    selectedPerson: "",
    selectedRelatedPerson: "",

    lastAddedPeople: [],

    people: [],
    relatedPeople: [],
    timezone_string: "",

    services: [],

    type_of_organisation: localStorage.getItem("type_of_organisation") || "Social Care",
    plannedEventOrAppointment: renderPlannedEventOrAppointment(),

    modal: false,
    loaded: false,
    peopleLoaded: true,
    servicesLoaded: false,
    relatedPeopleLoaded: false,
    assignableEventsLoaded: false,
    assignableEventsNeeded: false,
    assignableStaffMembersLoaded: false,
    updated: "",
    unauthorized: "",
    errors: "",
    error: "", 
    database_start_datetime: null, 
  };

  autoAssignStartTime() {
    // default to beginning of next hour
    let date = new Date();
    date.setHours(date.getHours() + 1)
    return `${date.getHours()}:00`
  }

  autoAssignEndTime() {
    // default to an hour after beginning of next hour
    let date = new Date();
    date.setHours(date.getHours() + 2)
    return `${date.getHours()}:00`
  }

  compileTime(datetime, timezone_string) {
    const jsDate = new Date(`${datetime}${timezone_string}`)
    return jsDate.toString()
  }

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    let start_datetime = name === "start_datetime" ? value : this.state.start_datetime
    let end_datetime = name === "end_datetime" ? value : this.state.end_datetime
    this.fetchAssignableEvents(start_datetime, end_datetime)

    if (name === "service_id") {
      this.updateEndTime(value)
    }

    if (name === "paid_with_cash" || name === "paid_with_card") {
      this.updateTotals(name, value)
    }

    this.setState({[name]: value});
  }

  handleTypeChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    this.handlePersonSearch(this.state.partial, value)
  }

  handlePartialChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value,
      peopleLoaded: false
    });

    this.debouncedHandlePersonSearch(value, this.state.type_of_person)
  }

  toggleModal(event) {
    const name = event.target.dataset.name

    this.setState(prevState => ({
      [name]: !prevState[name],
      message: ""
    }))
  }

  handlePersonSearch(partial, type_of_person) {
    if (partial.trim() === "") {
      this.setState({ peopleLoaded: true });
      return
    }

    let params = `person[location]=${this.props.match.params.location_id}&person[partial]=${partial}`

    if (type_of_person !== "") {
      params += `&person[type][]=${type_of_person}`
    }

    request('GET', `/v1/a/people/scoped_names_and_ids?${params}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ people: data, peopleLoaded: true })
      })
      .catch(error =>  handleRequestErrors(this, error, { peopleLoaded: true }))
  }

  handleAddRelatedPerson(type) {
    const person_id = parseInt(this.state.selectedRelatedPerson);
    const selectedRelationship = this.state.relatedPeople.find(relationship => relationship.person_id === person_id)

    this.setState(prevState => {
      const existingEntryIndex = prevState[type + "_people"].findIndex(
        entry => entry.person_id === person_id
      );
      
      if (existingEntryIndex > -1) {
        let arrayToUpdate = [...prevState[type + "_people"]];
        arrayToUpdate[existingEntryIndex]._destroy = false;
        
        return {
          [type + "_people"]: arrayToUpdate,
          selectedRelatedPerson: "",
          message: `${selectedRelationship.full_name} has been added!`
        };
      }

      const newEntry = {
        person_id: selectedRelationship.person_id,
        full_name: selectedRelationship.full_name
      };

      return {
        [type + "_people"]: [...prevState[type + "_people"], newEntry],
        selectedRelatedPerson: "",
        message: `${selectedRelationship.full_name} has been added!`
      };
    })
  }

  handleAddRelatedHostPerson(event) {
    event.preventDefault();
    this.handleAddRelatedPerson("host")
  }

  handleAddRelatedArrivingPerson(event) {
    event.preventDefault();
    this.handleAddRelatedPerson("arriving")
  }

  handleRemovePerson(event) {
    const name = event.currentTarget.attributes.name.value;
    const person_id = parseInt(event.currentTarget.id);
    
    this.setState(prevState => {
      const index = prevState[name].findIndex(entry => entry.person_id === person_id);
      let arrayToUpdate = [...prevState[name]];
      let entry = arrayToUpdate[index];

      if (entry.id) {
        entry._destroy = true;
      } else {
        arrayToUpdate.splice(index, 1);
      }

      return {
        [name]: arrayToUpdate,
      };
    })
  }

  handleGetRelatedPeople(event) {
    const id = parseInt(event.target.id);

    this.setState({
      relatedPeople: [],
      relatedPeopleLoaded: false,
      relationshipPersonID: id
    })

    request('GET', `/v1/a/people/${id}/relationships`, null, () => {this.setState({ unauthorized: true })})
      .then(data => {
        this.setState({ relatedPeople: data, relatedPeopleLoaded: true })
      })
      .catch(error =>  handleRequestErrors(this, error, { relatedPeopleLoaded: true }))
  }

  handleSelectPerson(event) {
    const type = event.target.dataset.type
    const person_id = parseInt(this.state.selectedPerson)
    const person = this.state.people.find(person => person.id === person_id)

    this.setState(prevState => {
      const existingEntryIndex = prevState[type + "_people"].findIndex(
        entry => entry.person_id === person_id
      );
      
      if (existingEntryIndex > -1) {
        let arrayToUpdate = [...prevState[type + "_people"]];
        arrayToUpdate[existingEntryIndex]._destroy = false;
        
        return {
          [type + "_people"]: arrayToUpdate,
          lastAddedPeople: [person.id],
          selectedPerson: "",
          message: `${person.full_name} has been added!`
        };
      }
      
      const newEntry = {
        person_id: person.id,
        full_name: person.full_name
      };

      return {
        [type + "_people"]: [...prevState[type + "_people"], newEntry],
        lastAddedPeople: [person.id],
        selectedPerson: "",
        message: `${person.full_name} has been added!`
      };
    })

    event.preventDefault();
  }

  handleStaffMemberCheckboxChange(event) {
    const personId = parseInt(event.target.name);
    const value = event.target.checked;

    this.setState(prevState => {
      let host_people = [...prevState.temp_host_people]
      const person = this.state.assignableStaffMembers.find(staff => staff.id === personId)

      const existingIndex = host_people.findIndex(host_person => host_person.person_id === personId);
      
      if (value === true) {
        if (existingIndex > -1) {
          host_people[existingIndex] = {
            ...host_people[existingIndex],
            _destroy: false
          };
        }
        else {
          host_people.push({
            person_id: personId,
            full_name: person.full_name
          });
        }
      }
      else if (value === false) {
        if (existingIndex > -1) {
          if (host_people[existingIndex].id) {
            host_people[existingIndex]._destroy = true;
          } else {
            host_people.splice(existingIndex, 1);
          }
        }
      }
      return { temp_host_people: host_people };
    });
  }

  handleStopGettingRelatedPeople(event) {
    this.setState({
      relationshipPersonID: "",
      message: ""
    })

    event.preventDefault();
  }

  handleSubmit(event) {
    var json = {
      "planned_event": {
        "title": this.state.title,
        "start_time": this.compileTime(this.state.start_datetime, this.state.timezone_string),
        "end_time": this.compileTime(this.state.end_datetime, this.state.timezone_string),
        "notes": this.state.notes,
        "planned_event_arriving_people_attributes": this.state.arriving_people,
        "planned_event_host_people_attributes": this.state.host_people,
        "service_id": this.state.service_id,
        "paid_with_cash": this.state.paid_with_cash,
        "paid_with_card": this.state.paid_with_card
      }
    }

    if (this.props.mode === "create") {
      json["planned_event"]["location_id"] = this.props.location_id
    }

    const [id, method] = setIdAndMethod(this.props.mode, this.props.id)

    request(method, `/v1/a/planned_events/${id}`, JSON.stringify(json), () => { this.setState({ unauthorized: true }) })
      .then(data => {
        sessionStorage.setItem("updateSuccess", `${this.state.plannedEventOrAppointment} ${this.props.mode}d successfully!`);

        this.props.closePanel()
      })
      .catch(error =>  handleRequestErrors(this, error))

    event.preventDefault();
  }

  handleDelete(event) {
    request("DELETE", `/v1/a/planned_events/${this.props.id}`, "", () => {this.setState({ unauthorized: true })})
      .then(data => {
        sessionStorage.setItem("updateSuccess", `${this.state.plannedEventOrAppointment} Deleted successfully!`);
        this.props.closePanel()
      })
      .catch(error => {handleRequestErrors(this, error)})

    event.preventDefault();
  }

  lastAdded(person_id) {
    return this.state.lastAddedPeople.includes(person_id) ? " flash-highlight" : ""
  }

  updateEndTime(service_id) {
    const service = this.state.services.find(service => service.id === parseInt(service_id))

    if (service) {
      const startDate = new Date(this.state.start_datetime)
      const newDate = new Date(startDate.getTime() + (service.duration * 60 * 1000))
      const dateString = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}T${String(newDate.getHours()).padStart(2, '0')}:${String(newDate.getMinutes()).padStart(2, '0')}`

      this.fetchAssignableEvents(this.state.start_datetime, dateString);
      this.setState({end_datetime: dateString})
    }
  }

  updateTotals(name, value) {
    value = value === "" ? 0 : parseFloat(value)

    const paid_with_cash = name === "paid_with_cash" ? value : parseFloat(this.state.paid_with_cash) || 0
    const paid_with_card = name === "paid_with_card" ? value : parseFloat(this.state.paid_with_card) || 0
    const deposit_amount = parseFloat(this.state.deposit_amount.replace('£', ''))
    const service_price = parseFloat(this.state.service_price.replace('£', ''))

    const total_amount_paid = paid_with_cash + paid_with_card + deposit_amount
    const amount_owed = Math.max(service_price - total_amount_paid, 0)

    this.setState({
      total_amount_paid: `£${total_amount_paid.toFixed(2)}`,
      amount_owed: `£${amount_owed.toFixed(2)}`
    })
  }

  renderAddedPeople(type) {
    const otherType = type === "host" ? "Arriving" : "Host"

    const addedPeople = this.state[type + "_people"].filter(addedPerson => !addedPerson._destroy)

    return (
      <div className="person-box">
        {addedPeople.map((addedPerson) => (
          <React.Fragment key={addedPerson.person_id}>
            <div className={"medium-bottom-padding" + this.lastAdded(addedPerson.person_id)}>
              <div>
                <span>{addedPerson.full_name}</span>
                {this.renderPersonButtons(type, addedPerson.person_id, otherType)}
              </div>
            </div>
            {this.renderRelatedModal(addedPerson.person_id, type, otherType)}
            {this.renderEvent(type, addedPerson.person_id)}
          </React.Fragment>
        ))}

        {addedPeople.length === 0 &&
          <div>No people added yet</div>
        }
      </div>
    )
  }

  renderPersonModal() {
    if (this.state.modal === true) {
      return (
        <div className="modal-container always-on-top">
          <div className="modal-content" style={{width: "60%"}}>
            <div className="modal-title">Add a Person</div>

            <TypeOfPersonSelect className="search-select bottom-margin" defaultText="Filter by Person Type" value={this.state.type_of_person} onChange={this.handleTypeChange} />
            <input name="partial" placeholder="Enter text to search" className="no-margin" onChange={this.handlePartialChange} value={this.state.partial} />
            {this.state.loaded === false ? (
              <select name="selectedPerson" className="no-margin" onChange={this.handleChange} value={this.state.selectedPerson}>
                <option value="">Loading...</option>
              </select>
            ) : (
              <select name="selectedPerson" className="no-margin" onChange={this.handleChange} value={this.state.selectedPerson}>
                <option value="">Select a Person ({this.state.people.length})</option>
                {this.state.people.map((person) => (
                  <option value={person.id} key={person.id} disabled={this.state.arriving_people.some(arriving_person => arriving_person.person_id === person.id && !arriving_person._destroy) || this.state.host_people.some(host_person => host_person.person_id === person.id && !host_person._destroy)}> {person.full_name}</option>
                ))}
              </select>
            )}

            <div className="center margin-top">
              { this.state.plannedEventOrAppointment !== "Appointment" && (
                <button className="button" disabled={this.state.selectedPerson === ""} onClick={this.handleSelectPerson} value={this.state.selectedPerson} data-type="host">Add as Host</button>
              )}
              <button className="button" disabled={this.state.selectedPerson === ""} onClick={this.handleSelectPerson} value={this.state.selectedPerson} data-type="arriving">
                Add as { this.state.plannedEventOrAppointment === "Appointment" ? "Client" : "Visitor" }
              </button>
            </div>

            {this.state.message}

            <div className="center margin-top">
              <div className="button center margin-top" data-name="modal" onClick={this.toggleModal}>Close</div>
            </div>
          </div>
        </div>
      )
    }
  }

  renderEvent(type, person_id) {
    if (type !== "arriving") {
      return null;
    }

    let arriving_person_with_event = this.state.arriving_people.find(arriving_person => arriving_person.person_id === person_id && arriving_person.event_id)

    if (arriving_person_with_event) {
      let check_in_text = arriving_person_with_event.event_check_in && arriving_person_with_event.event_check_in
      let check_out_text = arriving_person_with_event.event_check_out && arriving_person_with_event.event_check_out

      return (
        <div className="event-data">
          <div className="green-text">{check_in_text}</div>
          <div className="red-text">{check_out_text}</div>
        </div>
      )
    }
  }

  renderPersonButtons(type, person_id, otherType) {
    let arriving_person_with_event = type === "arriving" && this.state.arriving_people.some(arriving_person => arriving_person.person_id === person_id && arriving_person.event_id)
    return (
      <>
        { this.state.plannedEventOrAppointment !== "Appointment" && (
          <div className="tiny button right" name={type + "_people"} title="Add Related People" id={person_id} onClick={this.handleGetRelatedPeople}>+</div>
        )}

        {!arriving_person_with_event && <div className="tiny button right" name={type + "_people"} title="Remove Person" id={person_id} onClick={this.handleRemovePerson}><div className="rotate-45">+</div></div>}
      </>
    )
  }

  renderRelatedModal(id, type, otherType) {
    if (this.state.relationshipPersonID === id) {
      const handleAddOtherTypePerson = type === "host" ? this.handleAddRelatedArrivingPerson : this.handleAddRelatedHostPerson;
      let selectText

      if (this.state.relatedPeopleLoaded) {
        selectText = this.state.relatedPeople.length === 0 ? "No relations for this person" : "Select"
      }
      else {
        selectText = "Loading..."
      }

      return (
        <div className="modal-container">
          <div className="modal-content" style={{width: "60%"}}>
            <div className="modal-title">Add a Related Person</div>

            <select name="selectedRelatedPerson" className="column bottom-margin" onChange={this.handleChange} value={this.state.selectedRelatedPerson}>
              <option value="">{selectText}</option>
              {this.state.relatedPeople.map((person) => (
                <option value={person.person_id} key={person.person_id} disabled={this.state.arriving_people.some(arriving_person => arriving_person.person_id === person.person_id && !arriving_person._destroy) || this.state.host_people.some(host_person => host_person.person_id === person.person_id && !host_person._destroy)}>{person.full_name}</option>
              ))}
            </select>

            <div className="row center">
              <button className="small button" disabled={!this.state.selectedRelatedPerson} onClick={handleAddOtherTypePerson}>Add as {otherType} Person</button>
            </div>

            <div className="margin-top">{this.state.message}</div>

            <div className="row center margin-top">
              <div className="small button center" onClick={this.handleStopGettingRelatedPeople}>Close</div>
            </div>
          </div>
        </div>
      )
    }
  }

  renderSaveButton() {
    if (adminUser() || managerUser()) {
      return <input className="top-space" type="submit" value="Save" />
    }
    else {
      return <input className="top-space" type="submit" value="Sorry, you don't have permission to save changes" disabled="disabled" />
    }
  }

  renderDeleteButton() {
    const start = new Date(this.state.database_start_datetime);
    if (start < new Date()) {
      return null;
    }

    if (adminUser() || managerUser()) {
      return <div className="top-space button float-right red-button" onClick={this.handleDelete}>Delete</div>
    }
  }

  render() {
    const { title, placeholder_title, deposit, deposit_amount, amount_owed, paid_with_cash, paid_with_card, total_amount_paid, start_datetime, end_datetime, notes, service_id, services, servicesLoaded, loaded, type_of_organisation, plannedEventOrAppointment, unauthorized, errors, error } = this.state;
    if (this.state.loggedIn) {
      return <Redirect to="/"/>
    }

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false || servicesLoaded === false) {
      return <p>Loading ...</p>;
    }


    if (loaded && servicesLoaded) {
      const pageTitle = this.props.mode === "create" ? "New" : "Edit"
      const formatName = pageTitle ? ` ${pageTitle} |` : ""

      const service = services.find(service => service.id === parseInt(service_id))
      const eventDuration = duration(start_datetime, end_datetime)

      return (
        <div>
          <SetTitle title={`${formatName} ${plannedEventOrAppointment} | ${plannedEventOrAppointment}s`} />

          <form className="settings big-settings" onSubmit={this.handleSubmit}>
            {this.props.mode === "create" &&
              <div className="row">
                <div>{ this.renderAssignableEvents() }</div>
              </div>
            }

            {this.renderPersonModal()}

            <div className="row">
              <HelpText page={'planned_events'} section={'title'} plannedEventOrAppointment={plannedEventOrAppointment} />

              <label className="column">Title:</label>{ renderErrors(errors, 'title') }
              <input className="column" type="text" name="title" value={title} placeholder={placeholder_title} onChange={this.handleChange} />

              {title &&
                <NoticeBox type="info" text={`The Title will be used to refer to this ${plannedEventOrAppointment} both in emails to People and when checking in on Devices, as well as here on the calendar.`} />
              }
            </div>

            {type_of_organisation === "Retail" &&
              <>
                <div className="row">
                  <HelpText page={'planned_events'} section={'service'} plannedEventOrAppointment={plannedEventOrAppointment} />

                  <label className="column">Service:</label>{ renderErrors(errors, 'service') }
                  <select name="service_id" onChange={this.handleChange} value={service_id}>
                    <option value="">Select</option>
                    {services.map((service) => (
                      <option value={service.id} key={service.id}>{service.name} ({service.duration} minutes)</option>
                    ))}
                  </select>
                </div>

                {this.props.mode === "update" && service_id &&
                  <>
                    <div className="row small-bottom-margin negative-top-margin">
                      <HelpText page={'planned_events'} section={'deposit_amount'} plannedEventOrAppointment={plannedEventOrAppointment} />
                      <label className="column">Amount Deposited: {deposit ? deposit_amount : "N/A"}</label>
                    </div>

                    <div className="row small-bottom-margin">
                      <HelpText page={'planned_events'} section={'amount_owed'} plannedEventOrAppointment={plannedEventOrAppointment} />
                      <label className="column">Amount Owed: {amount_owed}</label>
                    </div>

                    <div className="row bottom-margin">
                      <HelpText page={'planned_events'} section={'total_amount_paid'} plannedEventOrAppointment={plannedEventOrAppointment} />
                      <label className="column">Total Amount Paid: {total_amount_paid}</label>
                    </div>

                    <div className="row">
                      <HelpText page={'planned_events'} section={'cash_amount_paid'} plannedEventOrAppointment={plannedEventOrAppointment} />
                      <label className="column">Cash Amount Paid:</label>{ renderErrors(errors, 'paid_with_cash') }
                      <input className="column" type="number" min="0" step="any" name="paid_with_cash" value={paid_with_cash} onChange={this.handleChange} />
                    </div>
        
                    <div className="row bottom-margin">
                      <HelpText page={'planned_events'} section={'card_amount_paid'} plannedEventOrAppointment={plannedEventOrAppointment} />
                      <label className="column">Card Amount Paid:</label>{ renderErrors(errors, 'paid_with_card') }
                      <input className="column" type="number" min="0" step="any" name="paid_with_card" value={paid_with_card} onChange={this.handleChange} />
                    </div>
                  </>
                }
              </>
            }

            <div className="half-row">
              <div className="row">
                <label className="column">Start Time:</label>{ renderErrors(errors, 'start_time') }
                <HelpText className="inline-block" page={'planned_events'} section={'start_time'} plannedEventOrAppointment={plannedEventOrAppointment} />

                <div>
                  <input className="column" type="datetime-local" name="start_datetime" value={start_datetime} onChange={this.handleChange} />
                </div>
              </div>

              <div className="row">
                <label className="column">End Time:</label>{ renderErrors(errors, 'end_time') }
                <HelpText className="inline-block"page={'planned_events'} section={'end_time'} plannedEventOrAppointment={plannedEventOrAppointment} />

                <div>
                  <input className="column" type="datetime-local" name="end_datetime" value={end_datetime} onChange={this.handleChange} />
                </div>
              </div>

            </div>

            {this.props.mode === "update" &&
              <div className="row align-right">
                <div>{ this.renderAssignableEvents() }</div>
              </div>
            }

            <div className="row">
              {service && service.duration > eventDuration  && eventDuration > 0 &&
                <NoticeBox type="info" text={`This Service normally takes ${service.duration} minutes but this ${plannedEventOrAppointment} is only has a ${eventDuration} minute duration.`}/>
              }
            </div>

            <div className="half-row">
              <h3>People</h3>
              
              { plannedEventOrAppointment !== "Appointment" && (
                <div className="row align-right">
                  <div className="button center margin-top" data-name="modal" onClick={this.toggleModal}>Add a Person</div>
                </div>
              )}
            </div>


            <div className="half-row">
              <div className="row">
                <label>{ plannedEventOrAppointment === "Appointment" ? "Staff Members" : "Host People" }:</label>
                <HelpText className="inline-block" page={'planned_events'} section={'host_people'} plannedEventOrAppointment={plannedEventOrAppointment} />

                { plannedEventOrAppointment === "Appointment" && (
                  <div className="inline right margin-right small-negative-top-margin">
                    { this.renderAssignableStaffMembers() }
                  </div>
                )}

                {this.renderAddedPeople("host")} { renderErrors(errors, 'host_person_ids') }
              </div>
              <div className="row">
                <label>{ plannedEventOrAppointment === "Appointment" ? "Clients" : "Arriving People" }:</label>
                <HelpText className="inline-block" page={'planned_events'} section={'arriving_people'} plannedEventOrAppointment={plannedEventOrAppointment} />

                { plannedEventOrAppointment === "Appointment" && (
                  <div className="inline right margin-right small-negative-top-margin">
                    <div className="button" data-name="modal" onClick={this.toggleModal}>Add Clients</div>
                  </div>
                )}

                {this.renderAddedPeople("arriving")} { renderErrors(errors, 'arriving_person_ids') }
              </div>
            </div>


            <div className="row big-top-space">
              <HelpText page={'planned_events'} section={'notes'} plannedEventOrAppointment={plannedEventOrAppointment} />

              <label className="column">Notes (will appear in confirmation and reminder emails!):</label>{ renderErrors(errors, 'title') }
              <textarea name="notes" value={notes} onChange={this.handleChange} />
            </div>

            { this.renderSaveButton() }
            { this.props.mode === "update" && this.renderDeleteButton() }
            { renderErrorWarning(errors) }
          </form>

          { this.props.mode === "update" && <Audits klass="PlannedEvent" id={this.props.id} /> }
        </div>
      );
    }
  }
    
  handleMultiCheckbox(event) {
    const assignableEventId = event.target.name;
    let value = event.target.checked;

    this.setState(prevState => {
      const usingTempForModal = prevState.temp_arriving_people;
      let arriving_people = usingTempForModal? [...prevState.temp_arriving_people]: [...prevState.arriving_people];
      const assignableEvent = prevState.assignableEvents.find(assignableEvent => assignableEvent.id === assignableEventId);
      const personId = assignableEvent.person_id;

      const existingIndex = arriving_people.findIndex(arriving_person => arriving_person.person_id === personId);
      
      if (value === true) {
        if (existingIndex > -1) {
          arriving_people[existingIndex] = {
            ...arriving_people[existingIndex],
            event_id: assignableEvent.id,
            event_check_in: assignableEvent.check_in,
            event_check_out: assignableEvent.check_out,
            _destroy: false
          };
        }
        else {
          arriving_people.push({
            person_id: personId,
            full_name: assignableEvent.person_name,
            event_id: assignableEvent.id,
            event_check_in: assignableEvent.check_in,
            event_check_out: assignableEvent.check_out,
            added_by_assignable_event: true
          });
        }
      }
      else if (value === false) {
        if (existingIndex > -1) {
          if (arriving_people[existingIndex].added_by_assignable_event) {
            arriving_people.splice(existingIndex, 1);
          }
          else {
            arriving_people[existingIndex].event_id = false;
            arriving_people[existingIndex].event_check_in = null;
            arriving_people[existingIndex].event_check_out = null;
          }
        }
      }
      return usingTempForModal? { temp_arriving_people: arriving_people }: { arriving_people: arriving_people };
    });
  }

  filterOutHostEvents() {
    const { host_people } = this.state;

    return this.state.assignableEvents.filter(assignableEvent =>
      !host_people.some(
        host_person => host_person.person_id === assignableEvent.person_id && !host_person._destroy
      )
    );
  }

  renderAssignableEvents() {
    if (!this.state.assignableEventsNeeded) return;

    const { plannedEventOrAppointment } = this.state;

    if (this.props.mode === "update") {
      const source = this.state.temp_arriving_people || this.state.arriving_people;
      return (
        <>
          <button type="button" className="button margin-bottom" onClick={this.openAssignableEventsModal}>View Assignable Events</button>
          <ModalContainerTrigger modalTitle="Assignable Events" full={true} closeModal={this.closeAssignableEventsModal} showModal={this.state.showAssignableEventsModal}>
            <AssignableEventsTable events={this.filterOutHostEvents()} selectedEventIds={source.filter(arriving_person => arriving_person.event_id && !arriving_person._destroy).map(arriving_person => arriving_person.event_id)} onChange={this.handleMultiCheckbox} loading={!this.state.assignableEventsLoaded} emptyMessage="No assignable Events at this Location around this time." assignmentHeader={`Assign to ${plannedEventOrAppointment}?`} displayTitle={false} />
              <div className="center-two-buttons">
                <button className="small button small-top-padding right" type="button" onClick={this.saveAssignableEventsModal}>Save</button>
              </div>
          </ModalContainerTrigger>
        </>
      )
    }else if (this.props.mode === "create") {
      return (
        <AssignableEventsTable events={this.filterOutHostEvents()} selectedEventIds={this.state.arriving_people.filter(arriving_person => arriving_person.event_id && !arriving_person._destroy).map(arriving_person => arriving_person.event_id)} onChange={this.handleMultiCheckbox} loading={!this.state.assignableEventsLoaded} emptyMessage="No assignable Events at this Location around this time." assignmentHeader={`Assign to ${plannedEventOrAppointment}?`} displayTitle={true} emptyMessageBackgroundColorClass="white-bg" />
      )
    }
  }

  renderAssignableStaffMembers() {
    return (
      <>
        <button type="button" className="button margin-bottom" onClick={this.openAssignableStaffMembersModal}>Add Staff</button>
        <ModalContainerTrigger modalTitle="Assignable Staff Members" full={true} closeModal={this.closeAssignableStaffMembersModal} showModal={this.state.showAssignableStaffMembersModal}>
          {this.renderAssignableStaffMembersTable()}
          <div className="center-two-buttons">
            <button className="small button small-top-padding right" type="button" onClick={this.saveAssignableStaffMembersModal}>Save</button>
          </div>
        </ModalContainerTrigger>
      </>
    )
  }

  renderAssignableStaffMembersTable() {
    const { assignableStaffMembers, plannedEventOrAppointment } = this.state;
    return (
        <div className="scrollable-table center bottom-margin">
          <table className="checkbox-table">
            <thead className="heading">
              <tr className="tr">
                <th className="th">Name</th>
                <th className="th">Status</th>
                <th className="th">{`Assign to ${plannedEventOrAppointment}?`}</th>
              </tr>
            </thead>

            <tbody>
              {assignableStaffMembers.map(staff => {
                const disabled = this.state.arriving_people.some(arriving_person => arriving_person.person_id === staff.id && !arriving_person._destroy);
                const statuses = { available: "Available", busy: "Already booked at this time", not_present: "Not on shift at this time"}
                
                return (
                  <tr className={"tr" + (staff.status === "not_present" ? " red" : "")} key={staff.id}>
                    <td className="td">{staff.full_name}</td>
                    <td className="td">{statuses[staff.status]}</td>
                    <td className="td">
                      <input type="checkbox" name={staff.id} checked={this.state.temp_host_people.some(host_person => host_person.person_id === staff.id && !host_person._destroy)} onChange={this.handleStaffMemberCheckboxChange} disabled={disabled} />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          {assignableStaffMembers.length === 0 && (
            <div className={`long-tr center white-bg`}>
              <div className="long-td">
                No Staff Members found at this Location for this time.
              </div>
            </div>
          )}
        </div>
    )
  }

  saveAssignableStaffMembersModal() {
    const { temp_host_people, host_people } = this.state;
    let lastAddedPeople = []

    temp_host_people.forEach(host_person => {
      if (!host_person._destroy) {
        if (!(host_people.find(existing_host => existing_host.person_id === host_person.person_id && !existing_host._destory))) {
          lastAddedPeople.push(host_person.person_id)
        }
      }
    })

    this.setState({ 
      host_people: temp_host_people,
      lastAddedPeople: lastAddedPeople 
    }, () => this.closeAssignableStaffMembersModal());
  }

  saveAssignableEventsModal() {
    this.setState(prevState => {
      return {arriving_people: prevState.temp_arriving_people};
    }, this.closeAssignableEventsModal);
  }

  closeAssignableEventsModal() {
    this.setState({
      temp_arriving_people: null,
      showAssignableEventsModal: false
    });
  }

  openAssignableEventsModal() {
    this.setState({
      temp_arriving_people: JSON.parse(JSON.stringify(this.state.arriving_people)),
      showAssignableEventsModal: true,
    });
  }

  openAssignableStaffMembersModal() {
    const { start_datetime, end_datetime, service_id } = this.state;
    const temp_host_people = JSON.parse(JSON.stringify(this.state.host_people));

    const params = `assignable[date_time_from]=${start_datetime}&assignable[date_time_to]=${end_datetime}&assignable[location_id]=${this.props.location_id}&assignable[service_id]=${service_id}&assignable[planned_event_id]=${this.props.id}`

    request('GET', `/v1/a/planned_events/assignable_staff_members?${params}`, null, () => {this.setState({ unauthorized: true })})
      .then(data => this.setState({assignableStaffMembers: data, assignableStaffMembersLoaded: true, showAssignableStaffMembersModal: true, temp_host_people: temp_host_people }))
      .catch(error =>  handleRequestErrors(this, error, { assignableStaffMembersLoaded: true, showAssignableStaffMembersModal: true, temp_host_people: temp_host_people }))
  }

  closeAssignableStaffMembersModal() {
    this.setState({ temp_host_people: [], showAssignableStaffMembersModal: false });
  }

  fetchAssignableEvents(start_datetime, end_datetime) {
    const start = new Date(start_datetime);

    if (start < new Date()) {
      this.setState({assignableEventsNeeded: true})

      let params = `assignable[date_time_from]=${start_datetime}&assignable[date_time_to]=${end_datetime}&assignable[location_id]=${this.props.location_id}`

      request('GET', `/v1/a/planned_events/assignable_events?${params}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({assignableEvents: data, assignableEventsLoaded: true })
        })
        .catch(error =>  handleRequestErrors(this, error, { assignableEventsLoaded: true }))
    }
    else {
      this.setState({assignableEventsNeeded: false})
    }
  }

  componentDidMount() {
    if (this.props.mode === "create") {
      if (this.props.date) {
        let year = this.props.date.getFullYear()
        let month = ("0" + (this.props.date.getMonth() + 1)).slice(-2)
        let day = ("0" + this.props.date.getDate()).slice(-2)

        let start_date = `${year}-${month}-${day}`
        let end_date = start_date

        // default to 12:00 to 13:00 when date has no time
        let start_time = "12:00"
        let end_time = "13:00"

        if (this.props.date.getHours() !== 0) {
          start_time = `${("0" + this.props.date.getHours()).slice(-2)}:00`
          end_time = `${("0" + (this.props.date.getHours() + 1)).slice(-2)}:00`
        }

        // default end date to tomorrow if end_time is at midnight
        if (end_time === "24:00") {
          end_date = new Date(end_date)
          end_date.setDate(end_date.getDate() + 1)

          year = end_date.getFullYear()
          month = ("0" + (end_date.getMonth() + 1)).slice(-2)
          day = ("0" + end_date.getDate()).slice(-2)

          end_date = `${year}-${month}-${day}`
          end_time = "00:00"
        }

        const start_datetime = `${start_date}T${start_time}`;
        const end_datetime = `${end_date}T${end_time}`;

        this.setState({
          start_datetime: start_datetime,
          end_datetime: end_datetime,
        })

        this.fetchAssignableEvents(start_datetime, end_datetime);
      }

      this.setState({loaded: true})
    }
    else if (this.props.mode === "update") {
      request('GET', `/v1/a/planned_events/${this.props.id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          const start_datetime = `${data.start_date}T${data.start_time}`
          const end_datetime = `${data.end_date}T${data.end_time}`

          this.setState({
            title: data.title || "",
            placeholder_title: data.placeholder_title,
            deposit: data.deposit,
            deposit_amount: data.deposit_amount,
            amount_owed: data.amount_owed,
            paid_with_cash: data.paid_with_cash || "",
            paid_with_card: data.paid_with_card || "",
            total_amount_paid: data.total_amount_paid,
            service_price: data.service_price,
            start_datetime: start_datetime,
            end_datetime: end_datetime,
            notes: data.notes || "",
            timezone_string: data.timezone_string,
            arriving_people: data.arriving_people,
            host_people: data.host_people,
            service_id: data.service_id,
            loaded: true,
            database_start_datetime: start_datetime,
          })

          this.fetchAssignableEvents(start_datetime, end_datetime);
        })
        .catch(error =>  handleRequestErrors(this, error, { loaded: true }))
    }

    if (this.state.type_of_organisation === "Retail") {
      request('GET', `/v1/a/services/names_and_ids`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          this.setState({ services: data, servicesLoaded: true })
        })
        .catch(error =>  handleRequestErrors(this, error, { servicesLoaded: true }))
    }
    else {
      this.setState({ servicesLoaded: true })
    }
  }
}

export default withRouter(PlannedEventForm);
